import InfoModal from './InfoModal';

export default InfoModal;
